<template>
  <div class="user-center">
    <header class="user-header" @click="toUserInfo">
      <div class="user-info">
        <van-image class="my-photo" round width="48" height="48" :src="userInfo.imgUrl | imgUrl('user')">
          <template v-slot:error>
            <van-icon size="48" :name="require('../../assets/imgs/default-user-avatar.png')"></van-icon>
          </template>
        </van-image>
        <span class="my-name">{{ userInfo.name }}</span>
      </div>

      <!-- <i class="name-icon van-icon van-icon-arrow" style="color: rgb(89, 89, 89)"></i> -->
      <van-icon class="name-icon" color="#595959" name="arrow"></van-icon>
    </header>

    <section class="user-list">
      <van-cell class="self-cell" is-link @click="jumpToCouponList">
        <template slot="title">
          <div class="cell-title">
            <van-icon class="cell-title-icon" size="24" :name="require('../../assets/imgs/coupon/yhq.png')"></van-icon>
            <span class="form-title">我的优惠券</span>
          </div>
        </template>
      </van-cell>

      <van-cell class="self-cell" is-link @click="jumpToRecipe">
        <template slot="title">
          <div class="cell-title">
            <van-icon
              class="cell-title-icon"
              size="24"
              :name="require('../../assets/imgs/ic_grzx_wdcf.png')"
            ></van-icon>
            <span class="form-title">我的用药建议</span>
          </div>
        </template>
      </van-cell>

      <!-- <van-cell class="self-cell" is-link @click="jumpToOrderList">
       
        <template slot="title">
          <div class="cell-title">
            <van-icon class="cell-title-icon" size="24" :name="require('../../assets/imgs/ic_my_order.png')"></van-icon>
            <span class="form-title">我的订单</span>
          </div>
        </template>
      </van-cell> -->

      <van-cell class="self-cell" is-link @click="jumpToCart">
       
       <template slot="title">
         <div class="cell-title">
           <van-icon class="cell-title-icon" size="24" :name="require('../../assets/imgs/ic_my_order.png')"></van-icon>
           <span class="form-title">我的需求清单</span>
         </div>
       </template>
     </van-cell>

      <van-cell class="self-cell" is-link @click="jumpToMedicalMember">
        <template slot="title">
          <div class="cell-title">
            <van-icon
              class="cell-title-icon"
              size="24"
              :name="require('../../assets/imgs/ic_my_medical.png')"
            ></van-icon>
            <span class="form-title">病历管理</span>
          </div>
        </template>
      </van-cell>

      <van-cell class="self-cell bottom-border" is-link @click="jumpToMallAddressList">
        <!-- <van-cell is-link :to="{ name: 'AddressManagement' }"> -->
        <template slot="title">
          <div class="cell-title">
            <van-icon
              class="cell-title-icon"
              size="24"
              :name="require('../../assets/imgs/ic_my_address.png')"
            ></van-icon>
            <span class="form-title">地址管理</span>
          </div>
        </template>
      </van-cell>

      <van-cell></van-cell>
    </section>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import jumpCenter from '@/mixins/jumpCenter';

export default {
  name: 'UserCenter',
  mixins: [jumpCenter],
  data() {
    return {};
  },
  computed: {
    ...mapState(['userInfo']),
    ...mapGetters(['basicInfoFilled', 'mobileBinded'])
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!(vm.mobileBinded && vm.basicInfoFilled)) {
        vm.$router.push({
          name: 'BindingInfo',
          query: { jumpUrl: location.href }
        });
      }
    });
  },
  components: {},
  methods: {
    ...mapActions(['getUserInfo']),
    toUserInfo() {
      if (this.mobileBinded && this.basicInfoFilled) {
        this.$router.push({ name: 'UserInfo' });
      } else {
        this.$router.push({
          name: 'BindingInfo',
          query: { jumpUrl: location.href }
        });
      }
    },
    jumpToRecipe() {
      this.$router.push({
        name: 'RecipeList'
      });
    },
    jumpToMedicalMember() {
      this.$router.push({
        name: 'CaseList'
      });
    },
    jumpToOrderList() {
      this.$router.push({
        name: 'orderList',
        params: {
          active: '0'
        }
      });
    },
    jumpToCouponList() {
      this.$router.push({
        name: 'couponList'
      });
    },
    jumpToCart() {
      this.$router.push({
        name: 'requestCart'
      });
    },
  }
};
</script>

<style lang="less" scoped>
.name-icon {
  font-size: 16px;
  line-height: 24px;
}
.user-center {
  height: 100%;
  background: #fff;
  .user-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 154px;
    padding: 0 20px;
    // background: linear-gradient(158deg, #3a9cfd 0%, #81bffd 100%);
    background: url('../../assets/imgs/img_my_bg.png') no-repeat top left/100% 100%;
    .user-info {
      display: flex;
      align-items: center;
      .my-name {
        margin-left: 16px;
        font: 500 24px/24px PingFangSC-Medium, PingFang SC;
        color: #ffffff;
      }
    }
  }
  .user-list {
    background: #fff;
    border-radius: 8px 8px 0px 0px;
    padding: 24px 16px 0;
    margin-top: -12px;
    .self-cell {
      margin-bottom: 13px;
      padding: 18px 0;
      ::v-deep.van-cell__flexrow {
        .van-icon {
          font-size: 16px;
          color: #d9d9d9;
        }
      }
      .form-title {
        margin-left: 12px;
        color: #262626;
      }
      .cell-title {
        display: flex;
        align-items: center;
        &-icon {
          height: 24px;
        }
      }
    }
  }
}
</style>
